<section>
  <div class="container">
    <tabset [justified]="true" #navigation>
      <tab [heading]="textFetch('Start')" style="padding: 0;">
        <app-start></app-start>
      </tab>
      <tab [disabled]="!(state === OrderState.ORDER)" [heading]="textFetch('Order')">
        <app-order></app-order>
      </tab>
      <tab [disabled]="!(state === OrderState.ACTIVATE)" [heading]="textFetch('Activate')">
        <app-activate></app-activate>
      </tab>
      <!--      <tab [disabled]="!(state === OrderState.CANCEL)" [heading]="textFetch('Renew')">-->
      <!--        <app-renew></app-renew>-->
      <!--      </tab>-->
      <tab [disabled]="!(state === OrderState.CANCEL)" [heading]="textFetch('Cancel')">
        <app-cancel-service></app-cancel-service>
      </tab>
      <tab [disabled]="!(state === OrderState.CANCEL)" [heading]="textFetch('Compromised_VSC')">
        <app-compromised></app-compromised>
      </tab>
    </tabset>
    <!-- POLLING EXPIRED TOAST -->
      <ng-template let-toast="toastRef" #pollingStopped>
        <div class="expired polling-stopped-toast" style="margin-left: 30px;">
          <span>{{ textFetch('Polling_stopped') }}</span>
          <button type="button" class="btn btn-secondary" (click)="reload()">
            <i class="siemens-reset"></i>
          </button>
        </div>
      </ng-template>
    </div>
</section>